import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <>
      <div className="bg-brand flex aspect-square size-8 items-center justify-center rounded-md text-white">
        <AppLogoIcon className="size-6" />
      </div>
      <div className="ml-1 grid flex-1 text-left text-sm">
        <span className="mb-0.5 truncate leading-tight font-semibold">
          SSS Directory
        </span>
      </div>
    </>
  )
}
